import React, { useContext } from 'react';
import { Caption1, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';

import { I18nContext } from '@bingads-webui-react/i18n-context';

const useAdsReviewInfoBannerStyles = makeStyles({
  root: {
    width: '930px',
    marginTop: tokens.spacingVerticalM,
  },
});

export const AdsReviewInfoBanner = () => {
  const i18n = useContext(I18nContext);
  const classes = useAdsReviewInfoBannerStyles();

  return (
    <MessageBar className={mergeClasses('ads-review-info-banner', classes.root)}>
      <MessageBarBody>
        <Caption1>
          {i18n.getString(_TL_('Reviewing your ad could take us one business day. Once reviewed, your ad will run.'))}
          {' '}
          {/* <Link
            href="#TODO"
            target="_blank"
            rel="noopener noreferrer"
            inline
          >
            {i18n.getString(_TL_('Learn more'))}
          </Link> */}
        </Caption1>
      </MessageBarBody>
    </MessageBar>
  );
};
